import { LocationTypesTranslations } from "./types";

export const enLocationTranslations: LocationTypesTranslations = {
    WAITING_ROOM: "Waiting Room",
    HOME_DISCHARGE: "Home",
    WARD_DISCHARGE: "Admitted to Ward",
    ITU_DISCHARGE: "Admitted to ITU",
    HDU_DISCHARGE: "Admitted to HDU",
    Majors: "Majors",
    Resus: "Resus",
    WaitingRoom: "Waiting Room",
    MajorBed1: "Majors",
    MajorBed2: "Majors",
    MajorBed3: "Majors",
    MajorBed4: "Majors",
    MajorBed5: "Majors",
    MajorBed6: "Majors",
    MajorBed7: "Majors",
    MajorBed8: "Majors",
    ResusBed1: "Resus",
    ResusBed2: "Resus",
    Chair1: "Waiting Room",
    Chair2: "Waiting Room",
    Chair3: "Waiting Room",
    Chair4: "Waiting Room",
    Chair5: "Waiting Room",
    Chair6: "Waiting Room",
    Chair7: "Waiting Room",
    Chair8: "Waiting Room",
    Chair9: "Waiting Room",
    Chair10: "Waiting Room",
    Chair11: "Waiting Room",
    Chair12: "Waiting Room",
    Chair13: "Waiting Room",
    Chair14: "Waiting Room",
    Chair15: "Waiting Room",
    Chair16: "Waiting Room",
    Chair17: "Waiting Room",
    Chair18: "Waiting Room",
    Chair19: "Waiting Room",
    Chair20: "Waiting Room",
};
